import { Typography } from '@snowball-tech/fractal/dist/src/components/Typography'

import isEmpty from 'lodash/fp/isEmpty'

type Props = {
  display?: boolean
  error?: Error | null
  message?: string
  showDetails?: boolean
}
export default function DisplayError({
  display = false,
  error,
  message,
  showDetails = true,
}: Props) {
  if (!error && !display) {
    return false
  }

  return (
    <>
      {!isEmpty(message) && (
        <Typography className="text-error" variant="body-2-bold">
          {message}
        </Typography>
      )}

      {(isEmpty(message) || (showDetails && error)) && (
        <Typography className="text-error" element="code" variant="body-2">
          {error?.toString()}
        </Typography>
      )}
    </>
  )
}
